// extracted by mini-css-extract-plugin
module.exports = {"InputLabel":"InputLabel_InputLabel__1O9WZ"};